import { Platform } from './platform'

export class PlatformBase extends Platform {
  constructor() {
    super()
  }
}
